import React, { useEffect, useState } from "react";
import {
  Form,
  DatePicker,
  Input,
  Radio,
  TimePicker,
  Row,
  Col,
  Button,
  Select,
} from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { robOptions } from "../../../Data/data";

const { Option } = Select;

function EditStaffVoyage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loader, set_loader] = useState(false);
  const [loadPorts, set_loadPorts] = useState([
    { port_name: "", arrival_draft: "", eta: "", departure_draft: "", etd: "" },
  ]);
  const [dischargePorts, set_dischargePorts] = useState([
    { port_name: "", arrival_draft: "", eta: "", departure_draft: "", etd: "" },
  ]);
  const [fuelData, setFuelData] = useState([]);

  const VIEW_API = async () => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("id", atob(id));
      const res = await post(ApiURL.view_voyage_info, FORM_DATA);
      if (res?.status === true) {
        const details = res?.voyage_details;
        form.setFieldsValue({
          voyage_no: details.voyage_no || "",
          voyage_time: details.voyage_time
            ? dayjs(details.voyage_time, "HH:mm:ss")
            : null,
          voyage_date: details.voyage_date ? dayjs(details.voyage_date) : null,
          voyage_type: details.voyage_type || "laden",
          charterer_speed: details.charterer_speed || "",
          fuel_consumption: details.fuel_consumption || "",
        });
        set_loadPorts(
          Array.isArray(details.load_ports) && details.load_ports.length > 0
            ? details.load_ports.map((port) => ({
                ...port,
                eta: port.eta ? dayjs(port.eta) : null,
                etd: port.etd ? dayjs(port.etd) : null,
              }))
            : [
                {
                  port_name: "",
                  arrival_draft: "",
                  eta: "",
                  departure_draft: "",
                  etd: "",
                },
              ]
        );
        set_dischargePorts(
          Array.isArray(details.discharge_ports) &&
            details.discharge_ports.length > 0
            ? details.discharge_ports.map((port) => ({
                ...port,
                eta: port.eta ? dayjs(port.eta) : null,
                etd: port.etd ? dayjs(port.etd) : null,
              }))
            : [
                {
                  port_name: "",
                  arrival_draft: "",
                  eta: "",
                  departure_draft: "",
                  etd: "",
                },
              ]
        );
        setFuelData(
          Array.isArray(details.rob_fuel) && details.rob_fuel.length > 0
            ? details.rob_fuel
            : [{ fuelType: null, Initialiy_rob: "" }]
        );
      } else {
        ErrorToast("Error", "Failed to fetch voyage details.");
      }
    } catch (error) {
      console.error("VIEW_API Error:", error);
      ErrorToast(
        "Error",
        "An unexpected error occurred while fetching voyage details."
      );
    } finally {
      set_loader(false);
    }
  };

  const GET_STAFF_DASHBOARD_DETAILS = async () => {
    try {
      const FORM_DATA = new FormData();
      const res = await post(ApiURL.staff_dashboard, FORM_DATA);
      if (res?.status === true) {
        localStorage.setItem(
          "staff_dashboard",
          JSON.stringify(res?.data || null)
        );
      } else {
        localStorage.setItem("staff_dashboard", JSON.stringify(null));
      }
    } catch (error) {
      console.error("Dashboard Fetch Error:", error);
      localStorage.setItem("staff_dashboard", JSON.stringify(null));
    }
  };

  const onFinish = async (values) => {
    set_loader(true);
    try {
      const formattedValues = {
        ...values,
        voyage_date: values.voyage_date
          ? values.voyage_date.format("YYYY-MM-DD")
          : "",
        voyage_time: values.voyage_time
          ? values.voyage_time.format("HH:mm:ss")
          : "",
        load_ports: loadPorts.map((port) => ({
          ...port,
          eta: port.eta ? dayjs(port.eta).format("YYYY-MM-DD HH:mm:ss") : "",
          etd: port.etd ? dayjs(port.etd).format("YYYY-MM-DD HH:mm:ss") : "",
        })),
        discharge_ports: dischargePorts.map((port) => ({
          ...port,
          eta: port.eta ? dayjs(port.eta).format("YYYY-MM-DD HH:mm:ss") : "",
          etd: port.etd ? dayjs(port.etd).format("YYYY-MM-DD HH:mm:ss") : "",
        })),
        rob_fuel: fuelData.filter(
          (fuel) => fuel.fuelType && fuel.Initialiy_rob
        ),
      };

      const FORM_DATA = new FormData();
      FORM_DATA.append("id", atob(id));
      FORM_DATA.append("voyage_type", formattedValues.voyage_type || "laden");
      FORM_DATA.append("voyage_time", formattedValues.voyage_time || "");
      FORM_DATA.append("voyage_date", formattedValues.voyage_date || "");
      FORM_DATA.append("voyage_no", formattedValues.voyage_no || "");
      FORM_DATA.append(
        "load_ports",
        JSON.stringify(formattedValues.load_ports)
      );
      FORM_DATA.append(
        "discharge_ports",
        JSON.stringify(formattedValues.discharge_ports)
      );
      FORM_DATA.append(
        "charterer_speed",
        formattedValues.charterer_speed || ""
      );
      FORM_DATA.append(
        "fuel_consumption",
        formattedValues.fuel_consumption || ""
      );

      const res = await post(ApiURL.edit_voyage_info, FORM_DATA);
      if (res?.status === true) {
        SuccessToast("Success", res?.message || "Voyage updated successfully!");
        await GET_STAFF_DASHBOARD_DETAILS();
        navigate("/staff-voyage-list");
      } else {
        ErrorToast("Error", res?.message || "Failed to update voyage.");
      }
    } catch (error) {
      console.error("EDIT_VOYAGE_API Error:", error);
      ErrorToast(
        "Error",
        "An unexpected error occurred. Please try again later."
      );
    } finally {
      set_loader(false);
    }
  };

  useEffect(() => {
    VIEW_API();
  }, [id]);

  const handleAddLoadPort = () => {
    set_loadPorts([
      ...loadPorts,
      {
        port_name: "",
        arrival_draft: "",
        eta: "",
        departure_draft: "",
        etd: "",
      },
    ]);
  };

  const handleAddDischargePort = () => {
    set_dischargePorts([
      ...dischargePorts,
      {
        port_name: "",
        arrival_draft: "",
        eta: "",
        departure_draft: "",
        etd: "",
      },
    ]);
  };

  const handleAddFuelType = () => {
    setFuelData([...fuelData, { fuelType: null, Initialiy_rob: "" }]);
  };

  const handleRemoveLoadPort = (index) => {
    if (loadPorts.length > 1) {
      set_loadPorts(loadPorts.filter((_, i) => i !== index));
    }
  };

  const handleRemoveDischargePort = (index) => {
    if (dischargePorts.length > 1) {
      set_dischargePorts(dischargePorts.filter((_, i) => i !== index));
    }
  };

  const handleRemoveFuelType = (index) => {
    if (fuelData.length > 1) {
      setFuelData(fuelData.filter((_, i) => i !== index));
    }
  };

  const handleFuelChange = (index, key, value) => {
    const updatedFuelData = [...fuelData];
    updatedFuelData[index][key] = value;
    setFuelData(updatedFuelData);
  };

  // Prevents typing the minus sign in numeric inputs
  const preventNegativeInput = (e) => {
    if (e.key === "-" || e.key === "e" || e.key === "E" || e.key === "+") {
      e.preventDefault();
    }
  };

  // Sanitises a numeric string to ensure it is non-negative
  const sanitizePositive = (val) => {
    if (val === "" || val === null || val === undefined) return val;
    const num = parseFloat(val);
    if (!isNaN(num) && num < 0) return "0";
    return val;
  };

  return (
    <div className="white-container">
      <h3>Update Voyage</h3>
      <br />
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item name="voyage_no" label="Voyage Number">
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              name="voyage_time"
              label="Time"
              rules={[{ required: true, message: "Please select the time" }]}
            >
              <TimePicker
                style={{ width: "100%" }}
                format="HH:mm:ss"
                defaultOpenValue={dayjs("00:00:00", "HH:mm:ss")}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="voyage_date"
              label="Date"
              rules={[{ required: true, message: "Please select the date" }]}
            >
              <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              name="voyage_type"
              label="Voyage Type"
              rules={[
                { required: true, message: "Please select the voyage type" },
              ]}
            >
              <Radio.Group>
                <Radio value="laden">Laden</Radio>
                <Radio value="ballast">Ballast</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        {/* Load Ports Section */}
        <div className="margin-top">
          <h4>Load Port(s)</h4>
          {loadPorts.map((port, index) => (
            <div key={index} style={{ marginBottom: 16 }}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <label className="block-label">Port Name</label>
                    {loadPorts.length > 1 && (
                      <CloseCircleOutlined
                        style={{ color: "red", cursor: "pointer", fontSize: "16px" }}
                        onClick={() => handleRemoveLoadPort(index)}
                      />
                    )}
                  </div>
                  <Input
                    value={port.port_name}
                    onChange={(e) =>
                      set_loadPorts((prev) => {
                        const updated = [...prev];
                        updated[index].port_name = e.target.value;
                        return updated;
                      })
                    }
                    placeholder="Enter Port Name"
                  />
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ marginTop: 8 }}>
                <Col span={6}>
                  <label className="block-label">Arrival Draft</label>
                  <Input
                    value={port.arrival_draft}
                    onChange={(e) =>
                      set_loadPorts((prev) => {
                        const updated = [...prev];
                        updated[index].arrival_draft = sanitizePositive(e.target.value);
                        return updated;
                      })
                    }
                    placeholder="Arrival Draft"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeInput}
                  />
                </Col>
                <Col span={6}>
                  <label className="block-label">ETA</label>
                  <DatePicker
                    showTime
                    format="YYYY-MM-DD HH:mm:ss"
                    value={port.eta}
                    style={{ width: "100%" }}
                    onChange={(date, dateString) =>
                      set_loadPorts((prev) => {
                        const updated = [...prev];
                        updated[index].eta = dateString
                          ? dayjs(dateString)
                          : null;
                        return updated;
                      })
                    }
                  />
                </Col>
                <Col span={6}>
                  <label className="block-label">Departure Draft</label>
                  <Input
                    value={port.departure_draft}
                    onChange={(e) =>
                      set_loadPorts((prev) => {
                        const updated = [...prev];
                        updated[index].departure_draft = sanitizePositive(e.target.value);
                        return updated;
                      })
                    }
                    placeholder="Departure Draft"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeInput}
                  />
                </Col>
                <Col span={6}>
                  <label className="block-label">ETD</label>
                  <DatePicker
                    showTime
                    format="YYYY-MM-DD HH:mm:ss"
                    value={port.etd}
                    style={{ width: "100%" }}
                    onChange={(date, dateString) =>
                      set_loadPorts((prev) => {
                        const updated = [...prev];
                        updated[index].etd = dateString
                          ? dayjs(dateString)
                          : null;
                        return updated;
                      })
                    }
                  />
                </Col>
              </Row>
            </div>
          ))}
          <Button
            type="dashed"
            onClick={handleAddLoadPort}
            style={{ marginTop: 8 }}
          >
            + Add Another Load Port
          </Button>
        </div>

        {/* Discharge Ports Section */}
        <div className="margin-top">
          <h4>Discharge Port(s)</h4>
          {dischargePorts.map((port, index) => (
            <div key={index} style={{ marginBottom: 16 }}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <label className="block-label">Port Name</label>
                    {dischargePorts.length > 1 && (
                      <CloseCircleOutlined
                        style={{ color: "red", cursor: "pointer", fontSize: "16px" }}
                        onClick={() => handleRemoveDischargePort(index)}
                      />
                    )}
                  </div>
                  <Input
                    value={port.port_name}
                    onChange={(e) =>
                      set_dischargePorts((prev) => {
                        const updated = [...prev];
                        updated[index].port_name = e.target.value;
                        return updated;
                      })
                    }
                    placeholder="Enter Port Name"
                  />
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ marginTop: 8 }}>
                <Col span={6}>
                  <label className="block-label">Arrival Draft</label>
                  <Input
                    value={port.arrival_draft}
                    onChange={(e) =>
                      set_dischargePorts((prev) => {
                        const updated = [...prev];
                        updated[index].arrival_draft = sanitizePositive(e.target.value);
                        return updated;
                      })
                    }
                    placeholder="Arrival Draft"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeInput}
                  />
                </Col>
                <Col span={6}>
                  <label className="block-label">ETA</label>
                  <DatePicker
                    showTime
                    format="YYYY-MM-DD HH:mm:ss"
                    value={port.eta}
                    style={{ width: "100%" }}
                    onChange={(date, dateString) =>
                      set_dischargePorts((prev) => {
                        const updated = [...prev];
                        updated[index].eta = dateString
                          ? dayjs(dateString)
                          : null;
                        return updated;
                      })
                    }
                  />
                </Col>
                <Col span={6}>
                  <label className="block-label">Departure Draft</label>
                  <Input
                    value={port.departure_draft}
                    onChange={(e) =>
                      set_dischargePorts((prev) => {
                        const updated = [...prev];
                        updated[index].departure_draft = sanitizePositive(e.target.value);
                        return updated;
                      })
                    }
                    placeholder="Departure Draft"
                    type="number"
                    min={0}
                    onKeyDown={preventNegativeInput}
                  />
                </Col>
                <Col span={6}>
                  <label className="block-label">ETD</label>
                  <DatePicker
                    showTime
                    format="YYYY-MM-DD HH:mm:ss"
                    value={port.etd}
                    style={{ width: "100%" }}
                    onChange={(date, dateString) =>
                      set_dischargePorts((prev) => {
                        const updated = [...prev];
                        updated[index].etd = dateString
                          ? dayjs(dateString)
                          : null;
                        return updated;
                      })
                    }
                  />
                </Col>
              </Row>
            </div>
          ))}
          <Button
            type="dashed"
            onClick={handleAddDischargePort}
            style={{ marginTop: 8 }}
          >
            + Add Another Discharge Port
          </Button>
        </div>

        {/* Charterer Details */}
        <Row gutter={[16, 16]} className="margin-top">
          <Col span={12}>
            <Form.Item
              name="charterer_speed"
              label="Instructed Charterer's Speed"
              rules={[
                {
                  validator: (_, value) =>
                    value === undefined || value === "" || parseFloat(value) >= 0
                      ? Promise.resolve()
                      : Promise.reject(new Error("Speed must be a positive value")),
                },
              ]}
            >
              <Input
                placeholder="Enter Charterer's Speed"
                type="number"
                min={0}
                onKeyDown={preventNegativeInput}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="fuel_consumption"
              label="Instructed Charterer's Fuel Consumption"
              rules={[
                {
                  validator: (_, value) =>
                    value === undefined || value === "" || parseFloat(value) >= 0
                      ? Promise.resolve()
                      : Promise.reject(new Error("Fuel consumption must be a positive value")),
                },
              ]}
            >
              <Input
                placeholder="Enter Fuel Consumption"
                type="number"
                min={0}
                onKeyDown={preventNegativeInput}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Fuel Types Section */}
        <div className="margin-top">
          <h4>Fuel / Lub Types and Initial ROB</h4>
          {fuelData.map((item, index) => (
            <div key={index} style={{ marginBottom: 16 }}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <label className="block-label">Select Fuel / Lub Type</label>
                    {fuelData.length > 1 && (
                      <CloseCircleOutlined
                        style={{ color: "red", cursor: "pointer", fontSize: "16px" }}
                        onClick={() => handleRemoveFuelType(index)}
                      />
                    )}
                  </div>
                  <Select
                    disabled
                    placeholder="-- Select Fuel Type --"
                    style={{ width: "100%" }}
                    value={item.fuelType}
                    // onChange={(value) => handleFuelChange(index, "fuelType", value)}
                    allowClear
                  >
                    {Array.isArray(robOptions) &&
                      robOptions.map((fuel, i) => (
                        <Option key={i} value={fuel.value}>
                          {fuel.label}
                        </Option>
                      ))}
                  </Select>
                </Col>
                <Col span={6}>
                  <label className="block-label">
                    Initial ROB ({item.fuelType || "-"})
                  </label>
                  <Input
                    disabled
                    value={item.Initial_rob}
                    placeholder="Enter ROB value"
                    type="number"
                  />
                </Col>
                <Col span={6}>
                  <label className="block-label">
                    Current ROB ({item.fuelType || "-"})
                  </label>
                  <Input
                    disabled
                    value={item.Initialiy_rob}
                    placeholder="Enter ROB value"
                    type="number"
                  />
                </Col>
              </Row>
            </div>
          ))}
        </div>

        <div className="input-box" style={{ marginTop: "15px" }}>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loader}>
              Save
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
}

export default EditStaffVoyage;
